import { all, fork, put, takeLatest, call, takeEvery } from 'redux-saga/effects';
import { createShopifyIntegrationAndStartOAuth as createShopifyIntegrationAndStartOAuthApi, } from '../../helpers';
import { commerceShipConnectorsApiResponseSuccess, commerceShipConnectorsApiResponseError, } from './actions';
import { CommerceShipConnectorsActionTypes } from './constants';
import { addToast } from '../actions';

export function* createShopifyIntegrationAndStartOAuthSaga({ payload: { shopifyIntegration } }) {
    try {
        const response = yield call(createShopifyIntegrationAndStartOAuthApi, shopifyIntegration);
        if (response.redirected) {
            window.location.href = response.url;
        } else {
            //TODO: this one should probably be a failure
            yield put(commerceShipConnectorsApiResponseSuccess(CommerceShipConnectorsActionTypes.CREATE_SHOPIFY_INTEGRATION_AND_START_OAUTH_REQUEST));
        }
    } catch (error) {
        yield put(addToast({ desc: error.errors[0].message, type: 'error' }));
        yield put(commerceShipConnectorsApiResponseError(CommerceShipConnectorsActionTypes.CREATE_SHOPIFY_INTEGRATION_AND_START_OAUTH_REQUEST, error));
    }
}

export function* watchCreateShopifyIntegrationAndStartOAuthSaga(): any {
    yield takeLatest(CommerceShipConnectorsActionTypes.CREATE_SHOPIFY_INTEGRATION_AND_START_OAUTH_REQUEST, createShopifyIntegrationAndStartOAuthSaga);
}

function* commerceShipConnectorsSaga() {
    yield all([
        fork(watchCreateShopifyIntegrationAndStartOAuthSaga),
    ]);
}

export default commerceShipConnectorsSaga;
